export default __webpack_public_path__ + "static/top_mv_pc-3a16583840a7d53380dad32a289377b2.jpg";